<template>

  <div class="RecoveryModulo">
    <h1>{{$t('recovery.title')}}</h1>
    <el-tabs v-model="activeTab" @tab-click="tabClick" :class="activeTab === 'second' ? 'secondTabSelected' : ''">
      <el-tab-pane :label="$t('recovery.username')" name="first">

        <el-form :model="RecUsernameForm" :rules="rulesUsernameForm" ref="RecUsernameForm" class="" :show-message=false>

          <el-form-item prop="mail" :class="{'is-error' : isErrorPwd}">
            <el-input v-model="RecUsernameForm.mail" v-bind:placeholder="$t('recovery.mail')" @change="clearError"
                      v-on:keyup.enter.native="submitFormUsername()"></el-input>
            <!--<icon name="riv-filter" scale="1.5" style="width: 20%;" @click.native="secretQuestion()"></icon>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="submitFormUsername()" class="btnSecretQuestion">{{$t('recovery.btn.userRecovery')}}
            </el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('recovery.pwd')" name="second">
        <el-form :model="RecPwdForm" :rules="rulesPwdForm" ref="RecPwdForm" class="" :show-message=false>

          <el-form-item prop="username" :class="{'is-error' : isErrorUsername}">
            <el-input v-model="RecPwdForm.username" v-bind:placeholder="$t('recovery.username')"
                      @change="clearError"></el-input>
            <!--<icon name="riv-filter" scale="1.5" style="width: 20%;" @click.native="secretQuestion()"></icon>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="secretQuestion()" class="btnSecretQuestion">{{$t('recovery.btn.checkUser')}}
            </el-button>
          </el-form-item>
          <el-form-item class="recovery" prop="rqsQstn" :class="{'is-error' : isErrorLogin}">
            <el-select v-model="RecPwdForm.rqsQstn" :disabled=true v-bind:placeholder="$t('recovery.rqsQstn')">
              <el-option
                v-for="item in secretQuestions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="ansQstn" :class="{'is-error' : isErrorLogin}">
            <el-input v-model="RecPwdForm.ansQstn" v-bind:placeholder="$t('recovery.ansQstn')" @change="clearError"
                      v-on:keyup.enter.native="submitFormPwd()"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitFormPwd()" class="btnSecretQuestion">{{$t('recovery.btn.pwdRecovery')}}
            </el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'RecoveryPassword',
    props: ['language'],
    data () {
      return {
        RecPwdForm: {
          username: '',
          rqsQstn: '',
          ansQstn: ''
        },
        RecUsernameForm: {
          mail: ''
        },
        rulesPwdForm: {
          username: [
            {required: true, trigger: 'blur'}
          ],
          rqsQstn: [
            {required: true, trigger: 'change'}
          ],
          ansQstn: [
            {required: true, trigger: 'blur'}
          ]
        },
        rulesUsernameForm: {
          mail: [
            {required: true, trigger: 'blur'}
          ]
        },
        loginVisible: true,
        isErrorLogin: false,
        isErrorUsername: false,
        isErrorPwd: false,
        secretQuestions: {},
        activeTab: 'first'
      }
    },
    i18n: {
      messages: {
        it_IT: {
          recovery: {
            title: 'Recupera Utente e Password',
            username: 'Username',
            rqsQstn: 'Domanda Segreta',
            ansQstn: 'Risposta Segreta',
            mail: 'e-Mail',
            pwd: 'Password',
            btn: {
              checkUser: 'Verifica Username',
              pwdRecovery: 'Recupera Password',
              userRecovery: 'Recupera Username'
            },
            msg: {
              errLogin: 'Username o password errati',
              1902: 'Timeout Exception: no response received',
              1903: 'Parametri della richiesta non validi',
              1907: 'Utente non presente',
              1908: 'Domanda Segreta non presente. Impossibile recuperare la Password',
              1909: 'Risposta Segreta errata',
              1910: 'Errore nell\'invio della mail',
              1913: 'Indirizzo eMail non presente nel sistema',
              1914: 'Impossibile procedere con la richiesta, l\'indirizzo eMail è associato a più profili',
              1915: 'Il nome Utente verrà inviato all\'indirizzo eMail indicato',
              1916: 'La Password Temporanea verrà inviata all\'indirizzo eMail inserito in fase di Registrazione',
              1998: 'Numero di filtri trovati non corretto',
              1999: 'Errore di autenticazione al servizio'
            }
          }
        },
        en_GB: {
          recovery: {
            title: 'Recover User and Password',
            username: 'Username',
            rqsQstn: 'Secret Question',
            ansQstn: 'Secret Answer',
            mail: 'e-Mail',
            pwd: 'Password',
            btn: {
              checkUser: 'Verify Username',
              pwdRecovery: 'Recover Password',
              userRecovery: 'Recover User'
            },
            msg: {
              errLogin: 'Username o password errati',
              1902: 'Timeout Exception: no response received',
              1903: 'Request parameter error',
              1907: 'This User does not exist',
              1908: 'Secret Question not present. Unable to recover the password',
              1909: 'Secret answer wrong',
              1910: 'Error in sending the mail',
              1913: 'E-mail adress not found in the system',
              1914: 'Unable to proceed with the request, the eMail address is associated with multiple profiles',
              1915: 'User name will be sent to the appointed e-mail address.',
              1916: 'Temporary password will be sent to the e-mail address indicated during registration operation',
              1998: 'Number of filters found incorrect',
              1999: 'Authentication error in the service'
            }
          }
        },
        es_ES: {
          recovery: {
            title: 'Recuperar nombre de usuario y contraseña',
            username: 'Usuario',
            rqsQstn: 'Pregunta secreta',
            ansQstn: 'Respuesta secreta',
            mail: 'e-Mail',
            pwd: 'Contraseña',
            btn: {
              checkUser: 'Verifica Usuario',
              pwdRecovery: 'Recuperar Contraseña',
              userRecovery: 'Recuperar Usuario'
            },
            msg: {
              errLogin: 'Username o password errati',
              1902: 'Timeout Exception: no response received',
              1903: 'Parámetros de la solicitud  no válidos',
              1907: 'Usuario no existente',
              1908: 'Pregunta secreta no presente. No se puede recuperar la contraseña',
              1909: 'Respuesta secreta equivocada',
              1910: 'Error al enviar el correo',
              1913: 'Este correo electrónico no está registrado por  el sistema',
              1914: 'No se puede continuar con la solicitud, la dirección de correo electrónico está asociada a múltiples perfiles',
              1915: 'El nombre de usuario será enviado a la dirección de correo electrónico indicada.',
              1916: 'La contraseña temporal será enviada a la dirección de correo electrónico introducida en nuestro sistema',
              1998: 'Cantidad de filtros encontrados incorrectos',
              1999: 'Error de autenticación en el servicio'
            }
          }
        },
        fr_FR: {
          recovery: {
            title: 'Récupération utilisateur et mot de passe',
            username: 'Utilisateur',
            rqsQstn: 'Question de sécurité',
            ansQstn: 'Réponse secrète',
            mail: 'Adresse email',
            pwd: 'Mot de passe',
            btn: {
              checkUser: 'Vérifiez Utilisateur',
              pwdRecovery: 'Récupération mot de passe',
              userRecovery: 'Récupération Utilisateur'
            },
            msg: {
              errLogin: 'Username o password errati',
              1902: 'Timeout Exception: no response received',
              1903: 'Les paramètres de la demande ne sont pas valables',
              1907: 'Utilisateur non reconnu',
              1908: 'Question de sécurité non présente. Impossible de récupérer le mot de passe',
              1909: 'Réponse de sécurité inexacte',
              1910: 'Erreur lors de l\'envoi du mail',
              1913: 'Adresse email inexistante dans le système',
              1914: 'Impossible de poursuivre la demande, l\'adresse e-mail est associée à plusieurs profils',
              1915: 'Le nom d\'utilisateur sera envoyé à l\'adresse mail indiquée',
              1916: 'Le mot de passe provisoire sera envoyé à l\'adresse mail saisie durant l\'inscription',
              1998: 'Nombre de filtres trouvés incorrects',
              1999: 'Erreur d\'authentification dans le service'
            }
          }
        },
        de_DE: {
          recovery: {
            title: 'Benutzername und Passwort wiederherstellen',
            username: 'Benutzer',
            rqsQstn: 'Geheime Frage',
            ansQstn: 'Geheime Antwort',
            mail: 'Emailadresse',
            pwd: 'Passwort',
            btn: {
              checkUser: 'Benutzerüberprüfung',
              pwdRecovery: 'Passwort wiederherstellen',
              userRecovery: 'Benutzername wiederherstellen'
            },
            msg: {
              errLogin: 'Username o password errati',
              1902: 'Timeout Exception: no response received',
              1903: 'Ungültige Parameter in der Anfrage',
              1907: 'Benutzer nicht existent',
              1908: 'Geheime Frage nicht vorhanden. Das Passwort konnte nicht wiederhergestellt werden',
              1909: 'Falsche geheime Antwort',
              1910: 'Fehler beim Senden der E-Mail',
              1913: 'Emailadresse existiert nicht im System',
              1914: 'Nicht in der Lage, mit der Anfrage fortzufahren, Die E-Mail-Adresse ist mehreren Profilen zugeordnet',
              1915: 'Der Benutzername wird an die angegebene Emailadresse geschickt',
              1916: 'Das temporäre Passwort wird an die bei der Registrierung vermerkte Emailadresse geschickt',
              1998: 'Anzahl der gefundenen Filter nicht korrekt',
              1999: 'Authentifizierungsfehler im Dienst'
            }
          }
        }
      }
    },
    beforeMount: function () {
      this.getSecretQuestions()
    },
    methods: {
      secretQuestion: function () {
        if (this.RecPwdForm.username) {
          this.$http.get('noauth/domandasic', {
            params: {
              codLang: this.$root.$i18n.locale.toLocaleString(),
              username: this.RecPwdForm.username
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.RecPwdForm.rqsQstn = response.body.data.rqsQstn
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }, response => {
              this.isErrorLogin = true
            })
        } else {
          this.isErrorUsername = true
        }
      },
      submitFormPwd: function () {
        this.$refs['RecPwdForm'].validate((valid) => {
          if (valid) {
            var obj = {
              username: this.RecPwdForm.username,
              ansQstn: this.RecPwdForm.ansQstn,
              codLang: this.$root.$i18n.locale.toLocaleString()
            }
            this.$http.post('noauth/pwdrecovery', obj)
              .then(response => {
                if (response.body.rc === 0) {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
              }, response => {
                this.isErrorLogin = true
              })
          } else {
            this.isErrorLogin = true
            return false
          }
        })
      },
      submitFormUsername: function () {
        this.$refs['RecUsernameForm'].validate((valid) => {
          if (valid) {
            let obj = {
              mail: this.RecUsernameForm.mail
            }
            this.$http.post('noauth/usernamerecovery', obj, {
              params: {
                codLang: this.$root.$i18n.locale.toLocaleString()
              }
            })
              .then(response => {
                if (response.body.rc === 0) {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
              }, response => {
                this.isErrorLogin = true
              })
          } else {
            this.isErrorLogin = true
            return false
          }
        })
      },
      clearError: function () {
        this.isErrorLogin = false
        this.isErrorUsername = false
        this.isErrorPwd = false
      },
      getSecretQuestions: function () {
        let obj = {
          params: {
            codLang: this.language
          }
        }
        this.$http.get('noauth/domandesic', obj)
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'secretQuestions', response.body.data)
            } else {
              this.$set(this, 'secretQuestions', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      tabClick: function (tab, event) {
        if (tab.label === 'Password'){
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .RecoveryModulo {
    height: 500px;
    padding: 15px 50px;
    h1 {
      text-align: right;
      .set-font(@weight: 300,@size: 24px, @color: #fff);
      margin-bottom: 20px;
    }
    .el-tabs {
      padding-top: 30px;
      width: 300px;
      text-align: center;
      margin-right: auto;
      margin-left: auto;
      .el-tabs__header {
        margin-bottom: 10px;
        height: 25px;
        width: 100%;
        .el-tabs__nav-wrap {
          border-bottom: 0px;
        }
        .el-tabs__nav-wrap::after {
          display: none;
        }
        .el-tabs__nav {
          width: 100%;
          .is-active {
            color: #fff;
          }
          .el-tabs__active-bar {
            background-color: #fff;
            height: 2px;
            width: 100%;
          }
        }
        .el-tabs__item {
          .set-font(@weight: 300,@size: 18px, @color: #000);
          width: 150px;
          text-align: center;
          height: 30px;
          line-height: 21px;
          padding-right: 0px;
          padding-left: 0px;
        }
        .el-tabs__item:hover {
          color: #fff;
        }
      }
      .el-tabs__item:hover {
        color: #fff;
      }
      .el-tabs__active-bar{
        background-color: #000;
      }
    }
    .el-form-item {
      text-align: center;
      margin-bottom: 0;
      .fa-icon {
        .set-font(@weight: 300,@size: 18px, @color: #fff);
      }
      &.is-error {
        .el-input__inner {
          outline: #f56c6c solid 1px;
          outline: rgba(255, 0, 0, 0.9) solid 1px;
          outline-offset: 0px;
        }
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          .set-font(@weight: 300,@size: 14px, @color: #000);
          display: block;
          margin: 5px auto;
          padding: 10px;
          width: 300px;
          border: 0;
          background-color: #fff;
          //background-color: rgba(255, 255, 255, .7);
          border: none;
          border-radius: 0px;
          line-height: 0;
          &:focus {
            outline: #000 solid 1px;
            outline: rgba(0, 0, 0, .4) solid 1px;
            outline-offset: 0px;
          }
        }
        ::placeholder {
          color:#a2a2a2;
          font-style: italic;
        }
      }
      &.recovery {
        padding-top: 30px;
      }
      .el-button {
        .set-font(@weight: 300,@size: 14px, @color: #fff);
        background-color: #000;
        background-color: rgba(0, 0, 0, .6);
        font-weight: 300;
        /*margin-top: 50px;*/
        /*margin-bottom: 45px;*/
        /*width:250px;*/
        transition: background-color .3s;
        border: 0;
        border-radius: 0;
        width: 300px;
        text-align: center;
        &:hover {
          background-color: #000;
          background-color: rgba(0, 0, 0, .8);
          cursor: pointer;
        }
        &:focus {
          outline: 0
        }
        &.btnSecretQuestion {
          margin: 5px auto;
          /*margin-top: 0px;*/
          /*margin-bottom: 10px;*/
        }
        &.btnRecovery {
          margin: 5px auto;
          /*margin-top: 0px;*/
          /*margin-bottom: 10px;*/
        }
      }
    }
    .errorLogin {
      .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
      //display: block;
      height: 22px;
      text-align: center;
    }
    .el-tabs__active-bar {
      width: 150px !important;
    }
    .secondTabSelected {
      .el-tabs__active-bar {
        transform: translateX(150px) !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login/Recovery.vue